<script type="text/babel">
export default {
    props: ['value', 'model'],

    data() {
        return {}
    },

    computed: {
        isToggled() {
            return this.value.filter(s => s.id === this.model.id).length >= 1
        },
    },

    methods: {
        toggle(bool = null) {
            bool = bool !== null ? bool : !this.isToggled

            this.$emit('input', bool ? this.toggleOn() : this.toggleOff())
        },

        toggleOn() {
            let excluded = this.toggleOff()
            excluded.push(this.model)
            return excluded
        },

        toggleOff() {
            return this.value.filter(s => s.id !== this.model.id)
        },
    },

    render() {
        return this.$scopedSlots.default({
            isToggled: this.isToggled,
            inputAttrs: {
                value: this.isToggled,
            },
            inputEvents: {
                input: this.toggle,
            },
            toggle: this.toggle,
        })
    },
}
</script>
